import { Link } from "react-router-dom";
import { Sparkles, ShieldCheck, Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-border/60 bg-background">
      <div className="mx-auto max-w-7xl px-6 py-12 md:px-10">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary">
                <Sparkles className="h-3.5 w-3.5 text-primary-foreground" />
              </div>
              <span className="font-display font-semibold">Zuntria</span>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-muted-foreground">The all-in-one AI super-app to make money, save together, and build your hustle.</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <span data-testid="trust-paypal-badge" className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2.5 py-1 text-[10px] font-medium text-muted-foreground">
                <ShieldCheck className="h-3 w-3 text-emerald-500" /> Secure PayPal payments
              </span>
              <span data-testid="trust-encrypt-badge" className="inline-flex items-center gap-1 rounded-full border border-border bg-card px-2.5 py-1 text-[10px] font-medium text-muted-foreground">
                <Lock className="h-3 w-3 text-primary" /> 256-bit TLS encrypted
              </span>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Product</div>
            <div className="mt-3 flex flex-col gap-2 text-sm">
              <Link to="/" className="text-muted-foreground hover:text-foreground">Home</Link>
              <Link to="/free-roadmap" data-testid="footer-roadmap-link" className="text-muted-foreground hover:text-foreground">Free Roadmap</Link>
              <Link to="/assistants" data-testid="footer-assistants-link" className="text-muted-foreground hover:text-foreground">AI Assistants</Link>
              <Link to="/pricing" className="text-muted-foreground hover:text-foreground">Pricing</Link>
              <Link to="/marketplace" className="text-muted-foreground hover:text-foreground">Marketplace</Link>
              <Link to="/ajo-savings" data-testid="footer-ajo-link" className="text-muted-foreground hover:text-foreground">Ajo &amp; Pardner Savings</Link>
              <Link to="/find-clients" data-testid="footer-findclients-link" className="text-muted-foreground hover:text-foreground">Find Clients (AI)</Link>
              <Link to="/ai-cv-builder" data-testid="footer-cvbuilder-link" className="text-muted-foreground hover:text-foreground">AI CV Builder</Link>
              <Link to="/job-tracker" data-testid="footer-jobtracker-link" className="text-muted-foreground hover:text-foreground">Job Tracker</Link>
              <Link to="/book" data-testid="footer-book-link" className="text-muted-foreground hover:text-foreground">Founder's Book</Link>
              <Link to="/blog" data-testid="footer-blog-link" className="text-muted-foreground hover:text-foreground">Guides &amp; Blog</Link>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Support</div>
            <div className="mt-3 flex flex-col gap-2 text-sm">
              <Link to="/about" data-testid="footer-about-link" className="text-muted-foreground hover:text-foreground">About us</Link>
              <Link to="/contact" data-testid="footer-contact-link" className="text-muted-foreground hover:text-foreground">Contact</Link>
              <Link to="/help" data-testid="footer-help-link" className="text-muted-foreground hover:text-foreground">Help &amp; FAQ</Link>
              <a href="mailto:support@zuntria.co.uk" data-testid="footer-support-email" className="text-muted-foreground hover:text-foreground">support@zuntria.co.uk</a>
              <a href="https://wa.me/447587831674" target="_blank" rel="noreferrer" className="text-muted-foreground hover:text-foreground">WhatsApp us</a>
              <a href="https://www.youtube.com/@Zuntria" target="_blank" rel="noreferrer" data-testid="footer-youtube-link" className="text-muted-foreground hover:text-foreground">YouTube</a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Legal</div>
            <div className="mt-3 flex flex-col gap-2 text-sm">
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-muted-foreground hover:text-foreground">Privacy Policy</Link>
              <Link to="/terms" data-testid="footer-terms-link" className="text-muted-foreground hover:text-foreground">Terms &amp; Conditions</Link>
              <Link to="/refund" data-testid="footer-refund-link" className="text-muted-foreground hover:text-foreground">Refund Policy</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-border/40 pt-6 text-xs text-muted-foreground md:flex-row md:items-center">
          <div>© {new Date().getFullYear()} Zuntria Limited. All rights reserved. Built by a solo founder, not a VC lab.</div>
          <div>Built with ♥ in London · Registered in the UK</div>
        </div>
      </div>
    </footer>
  );
}
